import { NavigateFunction } from "react-router-dom";
import { isQrCode } from "../../../utils";
import { navigateWithQr } from "../../../utils/routing.utils";
import { ORDER_TRACKING_ROUTE, ORDERS_ROUTE } from "../../../constants/routes";

type Params = {
    navigate: NavigateFunction;
    locationPath: string;
    orders: Record<string, any>[];
    multiple: boolean;
};

export const goToOrdersPath = ({
    navigate,
    locationPath,
    orders,
    multiple,
}: Params) => {
    const firstOrder = orders[0];
    const chargeId = firstOrder?.chargeId;

    if (!chargeId) {
        console.warn("Missing chargeId", orders);
        return;
    }

    if (isQrCode()) {
        navigateWithQr(
            navigate,
            locationPath,
            '/orderTraking',
            { state: { chargeId } }
        );
        return;
    }

    if (multiple) {
        navigate(ORDERS_ROUTE);
    } else {
        navigate(ORDER_TRACKING_ROUTE, {
            state: { chargeId },
        });
    }
};

